import React, { useEffect, useState, useContext } from "react";
import Spinner from "../../shared/spinner/Spinner";
import { get, handleError } from "../../shared/HttpReq";
import { Toast } from "../../shared/toaster/Toaster";

import LocPng from "../../assests/images/locataion.png";
// import YelowStar from "../../assests/images/Star.svg";
// import WhiteStar from "../../assests/images/Star2.svg";

import { useHistory } from "react-router-dom";
import Auth from "../../auth/Auth";
import AppContext from "../../shared/AppContext";

function Excursion_component() {
  const { setCompanyInfo } = useContext(AppContext);
  const [isLoading, setLoading] = useState(false);
  const [toaster, SetToaster] = useState({
    show: false,
    type: "", // type should be "danger" or "success"
    content: "",
  });
  const route = useHistory();
  const [excursionList, setExcursionData] = useState([]);
  const [changeLocation, setChangeLocation] = useState([]);
  const [changeAdventure, setChangedAdventure] = useState([]);
  const [adventureList, setAdventureData] = useState([]);


  //save Multiple adventures

  const filterChangeHandler = (checked, inputValue) => {
    if (checked) {
      setChangedAdventure((prevState) => [...prevState, inputValue]);
    } else {
      setChangedAdventure((prevState) => prevState.filter((itm) => itm !== inputValue));
    }
  };

  //save multiple locations

  const filterLocationHanlder = async(checked, inputValueLocation) => {
    if (checked) {
      setChangeLocation((prevState) => [...prevState, inputValueLocation]);
    } else {
      setChangeLocation((prevState) => prevState.filter((itm) => itm !== inputValueLocation));
    }
  };

  //authenicate company id

  const companyId = Auth.getCompanyID();

  //get all excursion detail
  const excursionDetail = async () => {
    setLoading(true);
    let res = await handleError(
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/company-excursions/${companyId}`,
        await get()
      )
    );

    setCompanyInfo({ name: res.data[0].company.name });
    if (res.status === 200) {
      setExcursionData(res.data);
    } else {
      SetToaster({
        show: true,
        type: "danger", // type should be "danger" or "success"
        content: res.errors,
      });
    }
    setLoading(false);
    setTimeout(() => {
      SetToaster({
        show: false,
        type: "",
        content: "",
      });
    }, 3000);
  };



  

  //get all Adventure list
  const getallAdventure = async () => {
    setLoading(true);
    let res = await handleError(
      await fetch(
        `${process.env.REACT_APP_BASE_URL}/company-adventure`,
        await get()
      )
    );
    if (res.status === 200) {
      setAdventureData(res.data);
    } else {
      SetToaster({
        show: true,
        type: "danger", // type should be "danger" or "success"
        content: res.errors,
      });
    }
    setLoading(false);
    setTimeout(() => {
      SetToaster({
        show: false,
        type: "",
        content: "",
      });
    }, 3000);
  };

  //filter excusion data

  const filterExcursion = async (location, name) => {
 
    setLoading(true);
    let res = await handleError(
      await fetch(
        `${
          process.env.REACT_APP_BASE_URL
        }/location/search/${companyId}?location=${location.toString()}&name=${name.toString()}`,
        await get()
      )
    );
    if (res.status === 200) {
      setExcursionData(res.data);
    } else {
      SetToaster({
        show: true,
        type: "danger", // type should be "danger" or "success"
        content: res.errors,
      });
    }
    setLoading(false);
    setTimeout(() => {
      SetToaster({
        show: false,
        type: "",
        content: "",
      });
    }, 3000);
  };

  //for clear all selected data
  function clearExcurionData() {
    setChangeLocation("");
    setChangedAdventure([]);

    let boxes = document.querySelectorAll(".tip_box");

    for (let i = 0; i < boxes.length; i++) {
      boxes[i].checked = false;
    }

    filterExcursion("", "");
  }


  useEffect(() => {
    excursionDetail();
    getallAdventure();
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
 
    filterExcursion(changeLocation,changeAdventure);
    // eslint-disable-next-line
  }, [changeLocation,changeAdventure]);


  return (
    <>
      {isLoading ? <Spinner /> : null}
      <Toast
        show={toaster.show}
        type={toaster.type}
        content={toaster.content}
        onClose={() =>
          SetToaster({
            show: false,
            type: "",
            content: "",
          })
        }
      />

      <div className="common_background pt-0 pb-0">
        <div className="container">
          {/* adventure trips starts */}
          <div className="adventure_trip row">
            <div className="col-lg-7 col-md-12">
              <div className="row">
                {excursionList.map((excusion) => (
                  <div
                    className="col-lg-6 col-md-12 col-sm-12 col-12"
                    key={excusion._id}
                  >
                    <div
                      className="adventure_trip_card"
                      style={{
                        backgroundImage: `url(${process.env.REACT_APP_BASE_URL}/media/?file=${excusion.images[0]})`,
                      }}
                      onClick={() =>
                        route.push(
                          "/Adventure_info/" + companyId + "/" + excusion._id
                        )
                      }
                    >
                      {/* <Link to="/Adventure_info"> */}
                      <div className="adventure_trip_card_details">
                        <h4 className="adventure_trip_card_details_heading">
                          {excusion.name}
                        </h4>
                        <div className="d-flex">
                          <span className="align-self-center">
                            <img src={LocPng} alt="Location Pic" />
                          </span>
                          <span className="adventure_trip_card_details_location">
                            {excusion.company.address}
                          </span>
                        </div>
                        <div className="adventure_trip_card_details_rating d-flex justify-content-end">
                          {/* <div className="star_divs">
                            <span>
                              <img src={YelowStar} alt="Yellow Star" />
                            </span>
                            <span>
                              <img src={YelowStar} alt="Yellow Star" />
                            </span>
                            <span>
                              <img src={YelowStar} alt="Yellow Star" />
                            </span>
                            <span>
                              <img src={WhiteStar} alt="Yellow Star" />
                            </span>
                            <span>
                              <img src={WhiteStar} alt="Yellow Star" />
                            </span>
                            <sup className="sup_rating">4.6</sup>
                          </div> */}
                          <h3 className="adventure_trip_card_details_rating_dollar">
                            ${" "}
                            {
                              excusion.pricing.sort((a, b) => {
                                if (a.price < b.price) {
                                  return -1;
                                }
                                if (a.price > b.price) {
                                  return 1;
                                }
                                return 0;
                              })[0].price
                            }
                          </h3>
                        </div>
                      </div>
                      {/* </Link> */}
                    </div>
                  </div>
                ))}

                {excursionList.length <= 0 && (
                  <div className="col-lg-12 col-md-12 col-sm-12 col-12">
                    <p className="no_result_found">No Result Found!</p>
                  </div>
                )}
              </div>
            </div>
            {/* gvdb */}
            <div className="col-lg-5 col-md-12 col-sm-12 col-12">
              <div className="filter_box">
                <div className="filter_box_wrapper">
                  <div className="heading_top">
                    <h3 className="everyday_color">Filter</h3>
                  </div>
                  <section className="filter-section">
                    <div className="section_heading">
                      <h4 className="everyday_color">Filter by location</h4>
                    </div>
                    <div className="section-filter_items">
                      <div className="filter_items-item">
                        <div className="position-relative">
                          <input
                            type="checkbox"
                            className="tip_box fp curser"
                            name="filterlocation"
                            id="croix"
                            value="forthlocation"
                            onChange={(e) => {
                              filterLocationHanlder(
                                e.target.checked,
                                "St. Thomas"
                              );
                            }}
                          />

                          <label htmlFor="twenty" className="filterlable">
                            St. Thomas
                          </label>
                        </div>
                      </div>

                      <div className="filter_items-item ">
                        <div className="position-relative">
                          <input
                            type="checkbox"
                            className="tip_box fp curser"
                            name="filterlocation"
                            id="croix"
                            value="firstlocation"
                            onChange={(e) => {
                              filterLocationHanlder(
                                e.target.checked,
                                "St. Croix"
                              );
                              // filterExcursion(changeLocation, changeAdventure);
                            }}
                          />

                          <label htmlFor="twenty" className="filterlable">
                            St. Croix
                          </label>
                        </div>
                      </div>

                      <div className="filter_items-item">
                        <div className="position-relative">
                          <input
                            type="checkbox"
                            className="tip_box fp curser"
                            name="filterlocation"
                            id="jhon"
                            value="secondlocation"
                            onChange={(e) => {
                              filterLocationHanlder(
                                e.target.checked,
                                "St. John"
                              );
                              // filterExcursion(changeLocation, changeAdventure);
                            }}
                          />

                          <label htmlFor="twenty" className="filterlable">
                            St. John
                          </label>
                        </div>
                      </div>

                      <div className="filter_items-item">
                        <div className="position-relative">
                          <input
                            type="checkbox"
                            className="tip_box fp curser"
                            name="filterlocation"
                            id="jamaica"
                            value="thirdlocation"
                            onChange={(e) => {
                              filterLocationHanlder(
                                e.target.checked,
                                "Jamaica"
                              );
                              // filterExcursion(changeLocation, changeAdventure);
                            }}
                          />

                          <label htmlFor="twenty" className="filterlable">
                            Jamaica
                          </label>
                        </div>
                      </div>
                    </div>
                  </section>
                  <section className="filter-section">
                    <div className="section_heading">
                      <h4 className="everyday_color">Filter by adventure</h4>
                    </div>
                    <div className="section-filter_items">
                      {adventureList.map((adventure) => (
                        <div key={adventure._id} className="filter_items-item">
                          <div className="position-relative">
                            <input
                              type="checkbox"
                              className="tip_box fp curser"
                              name="adventurefilter"
                              onChange={(e) => {
                                filterChangeHandler(
                                  e.target.checked,
                                  adventure.name
                                );
                                // filterExcursion(
                                //   changeLocation,
                                //   changeAdventure
                                // );
                              }}
                            />

                            <label htmlFor="twenty" className="filterlable">
                              {adventure.name}
                            </label>
                          </div>
                        </div>
                      ))}
                    </div>
                  </section>
                  <div className="submit_filter d-flex">
                    {/* <div className="submit_filter-save_btn">
                      <button
                        className="save_btn-save_filter active"
                        onClick={(e) => {
                          e.preventDefault();
                          filterExcursion(changeLocation, changeAdventure);
                        }}
                      >
                        Save
                      </button>
                    </div> */}
                    <div className="submit_filter-clear_btn">
                      <button
                        className="clear_btn-clear_filter"
                        onClick={clearExcurionData}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* adventure trips Ends */}
        </div>
      </div>
    </>
  );
}

export default Excursion_component;
